import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { UserSessionPersistenceService } from "@core/services";
import { AlertService } from "@shared/alert";
import { ProgressService } from "@shared/progress";
import { catchError, finalize, Observable, throwError } from "rxjs";

export function errorInterceptor(
    request: HttpRequest<any>,
    next: HttpHandlerFn
): Observable<HttpEvent<any>> {
    const progressService = inject(ProgressService);
    const alertService = inject(AlertService);
    const userSessionPersistenceService = inject(UserSessionPersistenceService);
    const router = inject(Router);

    progressService.start();

    return next(request).pipe(
        catchError((err: HttpErrorResponse) => {
            if (err instanceof HttpErrorResponse && err.status === 403) {
                router.navigate(['error/access-denied']);
                return throwError(() => err);
            } else if (err instanceof HttpErrorResponse && (err.status === 500 || err.status === 400)) {
                const isPendingApprovalError = err.status === 400 && err.error?.code === 'ACCOUNT_NOT_APPROVED';
                const error = isPendingApprovalError
                    ? 'This account is pending approval for this application.'
                    : err.error.message || err.statusText;
                alertService.error(error);

                if (err.status === 400 && error === 'Refresh token is invalid!') {
                    err.error.message += ' Logging out...';
                    setTimeout(() => {
                        userSessionPersistenceService.removeUserSession();
                        router.navigate(['/auth/login']);
                    }, 3000);
                }

                return throwError(() => err);
            } else if (err.status === 0) {
                const error = 'Unable to connect to server! Please try again.';
                alertService.error(error);
                return throwError(() => error);
            } else {
                const error = (err.error != undefined ? err.error.message : err.message) || err;
                alertService.error(error);
                return throwError(() => error);
            }
        }),
        finalize(() => progressService.complete())
    );
}
